<template>
    <div>
        <md-cell-item :title="ch.collectionworkerid" :brief="'Bonus ratio:' + ch.bonus_ratio + '%'" arrow>
            <iconimg name="logo" slot="left"></iconimg>
            <div slot="default">
                <div class="kyc-remark">Team size: {{ ch.teamcount }}</div>
                <div class="kyc-remark">Team performance: ₹ {{ ch.team_recharge }}</div>
                <div class="kyc-remark">
                    Commission: {{ch.commission}}
                </div>
                <div class="kyc-remark">
                    Senior Contact: {{ch.parent_collectionworkerid}}
                </div>
            </div>
            <span slot="right" @click="$_showActionSheet">Operating</span>
        </md-cell-item>
        <bonusratiodialog ref="bonusratiodialog" title="Edit Bonus ratio" :ch="ch" @on-createsuccess="notify_success"></bonusratiodialog>
        <transfertochild ref="transferto" :to="ch" @success="transfer_success"></transfertochild>
    </div>
</template>

<script>
import iconimg from '@/components/iconimg'
import pointtext from '@/components/pointtext'
import {ActionSheet, Dialog} from 'mand-mobile'
import bonusratiodialog from '@/components/bonusratiodialog'
import transfertochild from '@/components/transfertochild'


export default {
    name: 'myteamitem',
    props: {
        ch: {
            type: Object,
            default: {}
        }
    },
    components: {
        iconimg,
        pointtext,
        bonusratiodialog,
        transfertochild
    },
    data() {
        return {
            show: false,
            appendTo: document.body
        }
    },
    created() {},

    methods: {
        get_operate_options(){
            let options = [
                {
                    label: 'Edit Bonus ratio',
                    value: 'editbonusratio',
                },
                {
                    label: "Transfer Itoken",
                    value: "transferitoken"
                }
            ];
            return options
        },
        $_showActionSheet() {
            let options = this.get_operate_options();
            ActionSheet.create({
                value: true,
                title: 'Operate the Member',
                options: options,
                defaultIndex: 0,
                cancelText: 'Cancel',
                onCancel: this.$_cancel,
                onSelected: this.$_selected,
            })
        },
        $_selected(item) {
            if(item.value === "editbonusratio") {
                this.$refs.bonusratiodialog.showdialog();
            }
            if(item.value === "transferitoken") {
                this.$refs.transferto.showdialog();
            }
        },
        $_cancel() {
            console.log('action-sheet cancel')
        },
        notify_success(val) {
            this.$toast.succeed("Successfully modified");
            this.ch.bonus_ratio = val;
        },
        transfer_success() {
            this.$toast.succeed("transfer successful");
        }
    }
}

</script>
<style scoped>
.upi-text {
    max-width: 2rem;
}
.kyc-remark {
    color: #858b9c;
    font-size: 0.27rem;
}
.ct-status {
    display: inline;
}
.member-img {
    width: 1rem;
}
</style>



// WEBPACK FOOTER //
// src/views/my/myteamitem.vue